import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { TAB_BAR_HEIGHT } from '../../../appStyles/_layout.styles';

export const getLeagueSectionByDateStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      minHeight: 0,
    },
    list: {
      flex: 1,
    },
    listContent: {
      paddingBottom: TAB_BAR_HEIGHT + 24,
    },
    leagueBanner: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 12,
      marginTop: 4,
      marginBottom: 8,
      marginHorizontal: 16,
      backgroundColor: theme.primary + '12',
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.gray[200],
      gap: 10,
    },
    leagueBannerFlagWrap: {
      justifyContent: 'center',
    },
    leagueBannerText: {
      flex: 1,
      fontSize: 15,
      fontWeight: '800',
      color: theme.gray[800],
      textTransform: 'uppercase',
      letterSpacing: 0.6,
    },
    dateHeader: {
      paddingHorizontal: 16,
      paddingVertical: 10,
      backgroundColor: theme.gray[100],
    },
    dateHeaderText: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[600],
      textTransform: 'uppercase',
      letterSpacing: 0.6,
    },
    card: {
      backgroundColor: theme.background.card ?? theme.white,
      marginBottom: 2,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    sectionFooter: {
      height: 12,
    },
    leagueBannerPressed: {
      opacity: 0.8,
    },
  });
